import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from '.././global.service';
import { map, catchError } from 'rxjs/operators'
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TransactionService } from '../transaction.service';
const devUrl = environment.backendurl

@Injectable({
    providedIn: 'root'
})

export class ProfilesService {

    constructor(private http: HttpClient, private transactionService: TransactionService) { }

    /**
     * Get User Details
     * @param userid 
     * @returns 
     */
    fetchUserDetails(userid: string) {
        const url = devUrl + '/user/fetchdetails';
        const params = new HttpParams().set('usernumber', userid)
        return this.http.get(url, { params }).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('Get profile details data', url)))
    };


    /**
     * 
     * @param userid 
     * @param startindex 
     * @returns 
     */
    fetchpaymenttransactionhistory(userid: string, startindex: number) {
        let url = devUrl + "/paymentflow/fetchpaymenttransactionhistory?usernumber=" + userid + "&startindex=" + startindex
        return this.http.get(url).pipe(
            map(response => { return response; })
            , catchError(GlobalService.handleError('fetchcurrentplandetails', url)));
    };

    /**
     * Get current plan details
     * @description
     * Credits come from the shared signal on TransactionService (populated only on login and after
     * reveal-contact succeeds) - this no longer calls /paymentflow/fetchcurrentplancredits itself.
     * @param userid unused, kept for backward compatibility with existing call sites
     * @returns
     */
    fetchcurrentplandetails(userid?: string) {
        const creditsData = this.transactionService.credits();
        return of({ status: creditsData ? 'success' : 'error', data: creditsData });
    };

};